import { baseBeforeRender } from '@common';

baseBeforeRender.init();
